module.exports = __webpack_public_path__ + "static/media/sundance.17da6702.jpg";